import React from 'react';
import { StyledIcon } from './styled';

const Icon = ({ name, color, backgroundColor }) => (
  <StyledIcon className={name} color={color} backgroundColor={backgroundColor} />
);

export default Icon;
